var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { GET_BALANCE } from '../sagas/actions';
import * as BalanceActions from '../actions/balance';
export var combobetUrl = 'https://combo.fp.kz';
var initialState = {
    isLoading: null,
    value: 0,
};
export default function balance(state, action) {
    if (state === void 0) { state = initialState; }
    if (action === void 0) { action = {}; }
    switch (action.type) {
        case BalanceActions.FETCH_BALANCE:
        case GET_BALANCE.REQUEST:
            return __assign(__assign({}, state), { isLoading: true });
        case BalanceActions.SUCCESS_FETCH_BALANCE:
        case GET_BALANCE.SUCCESS:
            if (action.data && action.data.Error === undefined && action.data.message === undefined) {
                sendBalance(action.data);
                return __assign(__assign({}, state), { isLoading: false, value: action.data });
            }
            return state;
        case BalanceActions.FAILURE_FETCH_BALANCE:
        case GET_BALANCE.FAILURE:
            return __assign(__assign({}, state), { isLoading: false, value: 0 });
        default:
            return state;
    }
}
function sendBalance(balance) {
    if (document.getElementById('combobetFrame')) {
        var win = document.getElementById('combobetFrame').contentWindow;
        var data = {
            balance: balance
        };
        win.postMessage(data, combobetUrl);
    }
}



// WEBPACK FOOTER //
// ./src/reducers/balanceReducer.js